<template>
  <div ref="myAlert" class="custom-alert-pop">
    <van-popup
      v-model="vModel"
      :position="position ? position : 'center'"
      :overlay="overlay !== undefined ? overlay : true"
      @close="onClose"
    >
      <div class="alert-popup-wrapper">
        <span class="alert-title">{{ title ? title : "温馨提示" }}</span>
        <div v-if="useSlot === true" class="alert-content">
          <slot />
        </div>
        <div v-else class="alert-content" v-html="content" />
        <div v-if="button1Txt || button2Txt" class="alert-bottom">
          <button type="button" class="alert-button" @click="button1OnClick">
            {{ button1Txt ? button1Txt : "确定" }}
          </button>
          <button
            v-if="button2Txt"
            type="button"
            class="alert-button alert-cancel"
            @click="button2OnClick"
          >
            {{ button2Txt ? button2Txt : "取消" }}
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'AlertPop',
  props: [
    'useSlot',
    'position',
    'overlay',
    'duration',
    'closeable',
    'title',
    'content',
    'model',
    'alertOnClose',
    'button1Evt',
    'button2Evt',
    'button1Txt',
    'button2Txt',
    'autoHideDuration'
  ],
  data() {
    return {
      vModel: this.model
    }
  },
  watch: {
    model: function(newVal) {
      this.vModel = newVal
      if (newVal !== true) return
      this.startAutoHide()
    }
  },
  mounted() {},
  methods: {
    onClose() {
      this.$emit('alertOnClose')
    },
    button1OnClick() {
      this.onClose()
      this.$emit('button1Evt')
    },
    button2OnClick() {
      this.onClose()
      this.$emit('button2Evt')
    },
    startAutoHide() {
      if (isNaN(this.autoHideDuration)) return
      const myAlert = this.$refs.myAlert
      myAlert.style.transition = `opacity ${this.autoHideDuration /
        1000}s ease-in-out`
      setTimeout(() => {
        myAlert.classList.add('fade-me-out')
      }, 500)
      myAlert.addEventListener('transitionend', () => {
        this.onClose()
        myAlert.classList.remove('fade-me-out')
      })
    }
  }
}
</script>
<style>
.custom-alert-pop .van-popup {
  width: 90%;
  border-radius: 10px;
  opacity: 1;
}
.custom-alert-pop.fade-me-out {
  opacity: 0;
}
.custom-alert-pop .alert-popup-wrapper {
  font-size: 0.4rem;
  min-height: 2.3rem;
  /* padding-top: 0.6rem; */
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  /* padding-bottom: 0.3rem; */
}
.alert-popup-wrapper .alert-title {
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  font-size: 0.35rem;
  /* text-align: left; */
  font-weight: bold;
  /* padding-left: 0.3rem; */
  border-bottom: 0.01rem solid rgba(51, 51, 51, 0.4);
}
.alert-popup-wrapper .alert-content {
  /* flex: 1; */
  /* display: flex; */
  /* flex-direction: column; */
  /* justify-content: center; */
  /* align-items: center; */
  font-size: 0.3rem;
  min-height: 1.2rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  max-height: 380px;
  overflow-y: scroll;
}

.alert-popup-wrapper .alert-bottom {
  border-top: 0.01rem solid rgba(51, 51, 51, 0.4);
  padding-top: 0.05rem;
  padding-bottom: 0.05rem;
  display: flex;
}
.alert-popup-wrapper .alert-button {
  border: none;
  background-color: transparent;
  font-size: 0.3rem;
  color: rgb(31, 158, 219);
  padding: 0.2rem 0.4rem;
  flex:1;
}
.alert-popup-wrapper .alert-button.alert-cancel {
  color: tomato;
}

.alert-popup-wrapper ul li {
  padding-left: 0.2rem;
  /* margin-top: 0.15rem; */
}

.alert-popup-wrapper ul.enable-list-type li {
  list-style: decimal;
}

.alert-popup-wrapper ul.enable-list-type.A li {
  list-style: upper-alpha;
}

.alert-popup-wrapper ul ul {
  margin-left: 0.4rem;
}
.alert-popup-wrapper .red {
  color: red;
}
</style>
